import {
  colorStopToString,
  calculateRadialStop,
  fixTransparentColorStops,
} from '../color-utils.js';

/**
 * Render a radial gradient
 * @param {CanvasRenderingContext2D} context - Canvas context
 * @param {Object} gradientDef - Gradient definition from parser
 * @param {Object} bounds - Bounding box { x, y, w, h }
 * @returns {CanvasGradient} Canvas gradient object
 */
export function renderRadialGradient(context, gradientDef, { x, y, w, h }) {
  // Parse radial gradient shape and size from orientation
  const orientation = gradientDef.orientation
    ? gradientDef.orientation[0]
    : { type: 'shape', value: 'ellipse' };

  const isCircle = orientation?.type === 'shape' && orientation.value === 'circle';

  // Calculate gradient parameters based on shape
  const centerX = x + w / 2;
  const centerY = y + h / 2;
  const radius = isCircle ? Math.min(w, h) / 2 : Math.max(w, h) / 2;

  // Create radial gradient with inner and outer circles
  const gradient = context.createRadialGradient(
    centerX,
    centerY,
    0, // Start circle (center)
    centerX,
    centerY,
    radius // End circle
  );

  // Clone colorStops to avoid mutating the original
  const colorStops = gradientDef.colorStops.map((stop) => ({ ...stop }));

  // Fix transparent color stops to match CSS premultiplied alpha behavior
  fixTransparentColorStops(colorStops);

  // Add color stops based on the gradient definition
  colorStops.forEach((stop, index) => {
    const position = calculateRadialStop(stop, index, radius);
    const colorValue = colorStopToString(stop);

    if (colorValue) {
      gradient.addColorStop(Math.max(0, Math.min(1, position)), colorValue);
    }
  });

  return gradient;
}
